import { render, staticRenderFns } from "./KnowledgeAdd.vue?vue&type=template&id=3e8128de&scoped=true&"
import script from "./KnowledgeAdd.vue?vue&type=script&lang=js&"
export * from "./KnowledgeAdd.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeAdd.vue?vue&type=style&index=0&id=3e8128de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8128de",
  null
  
)

export default component.exports